// eslint-disable-next-line import/prefer-default-export
export const QuizTypes = {
  ADD_QUIZ: 'ADD_QUIZ',
  SAVE_QUIZ: 'SAVE_QUIZ',
  ADD_QUESTION: 'ADD_QUESTION',
  EDIT_MODE: 'EDIT_MODE',
};
